export default __webpack_public_path__ + "static/media/article.f0b20d98.svg";